
export default {
  props: {
    history: {
      type: Array,
      required: true
    }
  },
  emits: ['close'],
  data(){
    return {
      steps: [],
      current_step: 0
    }
  },
  computed:{
    last_answer(){
      return this.history.findLast(x => x.type === 'assistant')
    },
    open(){
      return !!this.steps?.length
    },
  },
  watch: {
    last_answer: { 
      handler() {
        const progress = this.last_answer?.data?.progress
        if (progress) {
          this.current_step = progress.current_step
          this.steps = progress.steps
        }
      }, 
      deep: true,
      immediate: true
    }
  }
}
